import React, { FC } from 'react'
import { Plural } from '@lingui/macro'
import { Box } from 'front-end/src/components'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import IconEnergy from '../../../components/common/icon/IconEnergy'
import { brandColors } from '../../../../../shared/basicPalette'
import {
  RelatedInstanceItem,
  RelatedInstancesWrapper
} from '../../../components/common/related-instances/RelatedInstances'
import { uniqBy } from 'lodash'
import { GroupRelatedCampaignsFragment } from './GroupRemoveModal.codegen'
import { CampaignFilterTypeEnum } from '../../../../../shared/enums/campaigns'

type RelatedCampaigns = GroupRelatedCampaignsFragment['relatedCampaigns']

type ResourceRelatedInstancesProps = {
  campaigns: RelatedCampaigns
}

export const getGroupFiltersByCampaign = (uniqCampaigns: RelatedCampaigns) => {
  return uniqCampaigns.reduce((acc, campaign) => {
    const groupIds = campaign.filters
      .filter(
        (campaignFilter) =>
          campaignFilter.type === CampaignFilterTypeEnum.group &&
          campaignFilter.ref_ids &&
          campaignFilter.ref_ids.length > 0
      )
      .map((campaignFilter) => campaignFilter.ref_ids)

    acc[campaign.id] = new Set(groupIds.flat())

    return acc
  }, {})
}

export const ResourceRelatedInstances: FC<ResourceRelatedInstancesProps> = ({
  campaigns
}) => {
  const uniqueCampaigns = uniqBy(campaigns, 'id') as RelatedCampaigns
  const groupFiltersByCampaign = getGroupFiltersByCampaign(uniqueCampaigns)

  return (
    <Box mb="16px">
      <RelatedInstancesWrapper>
        {uniqueCampaigns.map((campaign) => {
          return (
            <RelatedInstanceItem
              key={`campaign-${campaign.id}`}
              id={campaign.id}
              href={`${linkBuilder.campaign(campaign.id)}`}
              icon={<IconEnergy color={brandColors.grey.mid} />}
              info={
                <Plural
                  one="# group"
                  other="# groups"
                  value={groupFiltersByCampaign[campaign.id].size}
                />
              }
              name={campaign.name}
              additionalInfo={campaign.author?.userIdentity}
            />
          )
        })}
      </RelatedInstancesWrapper>
    </Box>
  )
}
